const timeMinutes = value => {
  if (value == null || value === '') return null;
  if (String(value).includes(':')) {
    const [hours, minutes] = String(value).split(':').map(Number);
    return hours * 60 + minutes;
  }
  return Math.floor(Number(value) / 100) * 60 + Number(value) % 100;
};

export const toLocalDateTimeInput = value => String(value || '').trim()
  .replace(' ', 'T')
  .replace(/(?:Z|[+-]\d\d:\d\d)$/i, '')
  .slice(0, 16);

export const toLocalDateTimeValue = value => `${toLocalDateTimeInput(value)}:00`;

export const scheduleEndAfterHour = start => {
  if (!start) return '';
  if (/^\d{2}:\d{2}$/.test(start)) {
    const minutes = timeMinutes(start) + 60;
    return minutes < 1440 ? `${String(Math.floor(minutes / 60)).padStart(2, '0')}:${String(minutes % 60).padStart(2, '0')}` : '';
  }
  const date = new Date(`${toLocalDateTimeValue(start)}Z`);
  date.setUTCHours(date.getUTCHours() + 1);
  return date.toISOString().slice(0, 16);
};

export const schoolWallClockToIso = (date, time) => {
  const value = new Date(`${date}T${time}:00Z`);
  return Number.isFinite(value.getTime()) ? value.toISOString() : null;
};

const scheduleDate = (value, localWallClock) => {
  if (!value) return new Date(NaN);
  const text = String(value).trim().replace(' ', 'T');
  if (localWallClock) return new Date(`${text.replace(/(?:Z|[+-]\d\d:\d\d)$/i, '')}Z`);
  return new Date(/(?:Z|[+-]\d\d:\d\d)$/i.test(text) ? text : `${text}Z`);
};

export const getLocationOverride = (schedule, instant, localWallClock = false) => {
  const overrides = schedule?.scheduleOverrides || schedule?.overrides || [];
  const matches = overrides.filter(override => instant >= scheduleDate(override.startDateTime || override.startDatetime, localWallClock) && instant < scheduleDate(override.endDateTime || override.endDatetime, localWallClock));
  if (matches.some(override => override.overrideType === 'off')) return 'off';
  return matches.some(override => override.overrideType === 'on') ? 'on' : null;
};

export const isLocationScheduleAvailable = (schedule, instant, allowMissing = false, localWallClock = false) => {
  if (!schedule) return allowMissing;
  const override = getLocationOverride(schedule, instant, localWallClock);
  if (override) return override === 'on';
  const day = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'][instant.getUTCDay()];
  const start = timeMinutes(schedule[`${day}Start`]);
  const end = timeMinutes(schedule[`${day}End`]);
  const minutes = instant.getUTCHours() * 60 + instant.getUTCMinutes();
  return start != null && end != null && minutes >= start && minutes < end;
};

export const getBookedResourceRate = (reservation, resourceType, resourceId, fallback) => {
  const bookedResourceId = resourceType === 'aircraft' ? reservation?.aircraftId : reservation?.userIdInstructor;
  const snapshot = resourceType === 'aircraft' ? reservation?.aircraftRate : reservation?.instructorRate;
  return Number(resourceId) === Number(bookedResourceId) && snapshot != null ? Number(snapshot) : Number(fallback ?? 0);
};